import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const MessageContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: var(--padding-1) 0;
	font-size: var(--paragraph3-font-size);

	> div.flexRow {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		> p.conflictingRule {
			background-color: var(--red);
			color: var(--white);
			padding: var(--padding-2) var(--padding-3);
			margin: var(--margin-2) var(--margin-2) 0 0;
			border-radius: var(--small-border-radius);
			body[dir='rtl'] & {
				margin: var(--margin-2) 0 0 var(--margin-2);
			}
		}
	}
`;

export const ResultContainer = styled.div`
	display: flex;
	flex-direction: column;
	grid-gap: 2rem;
	width: 100%;
	padding: 1rem;
`;

export const TestResultContainer = styled.div`
	align-items: flex-start;
	justify-content: flex-start;
	gap: 1rem;
	width: 100%;
	border: 1px solid var(--border-color);
	padding: 2rem;
	border-radius: var(--small-border-radius);

	${({ isExpanded }) =>
		isExpanded &&
		css`
			border-bottom-left-radius: 0;
			border-bottom-right-radius: 0;
			&.success {
				border-color: var(--green);
			}
			&.failed {
				border-color: var(--red);
			}
		`}
	display: grid;
	grid-template-columns: 0.4fr 1fr 1.5fr 1fr 1.5fr 0.3fr;
	place-items: center;
	gap: 1rem;
	overflow: hidden;

	@media ${Breakpoints.mobileLandscape} {
		align-items: center;
		display: flex;
		flex-direction: column;
		& > div {
			padding-bottom: 1rem;
		}
	}
`;

export const TestDetailsContainer = styled.div`
	border: 1px solid var(--border-color);
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	padding: 2rem;
	${({ isExpanded }) =>
		isExpanded &&
		css`
			&.success {
				border-color: var(--green);
			}
			&.failed {
				border-color: var(--red);
			}
		`}
`;

export const TitleRowContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	gap: 1rem;
	width: 100%;
	overflow: hidden;
	/* flex: 1; */

	&.order-row {
		flex-direction: row;
		align-items: center;
	}
`;

export const RowContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: flex-start;
	align-items: center;
	gap: 0.5rem;
	width: 100%;
	flex: 1;
	&.dc {
		align-items: center;
	}
	@media ${Breakpoints.mobileLandscape} {
		align-items: center;
		&.outer {
			flex-direction: column;
		}
	}
	& > .form-item {
		flex: 1 1 auto;
	}
`;

export const ColContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	gap: 1rem;
	width: 100%;
	flex: 1;

	@media ${Breakpoints.mobileLandscape} {
		align-items: center;
		&.outer {
			flex-direction: column;
		}
	}
	& > .form-item {
		flex: 1 1 auto;
	}
`;

export const TestResultContent = styled.div`
	display: flex;
	gap: 0.1rem;
	align-items: center;
`;

export const Line = styled.span`
	height: 1px;
	min-height: 1px;
	background-color: var(--border-color);
	width: 100%;
	display: block;
	margin: 3rem 1rem;
`;

export const TestResultWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;
